import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserStore } from '../../../state';

interface PermissionRouteGuardProps {
    children: React.ReactNode;
    requiredPermission: string;
    redirectTo?: string;
}


const PermissionRouteGuard: React.FC<PermissionRouteGuardProps> = ({ children, requiredPermission, redirectTo = "/app/transaction-summary" }) => {
    const userConfig = useUserStore(state => state.userConfig);

    const { usersPermissions } = userConfig;

    const hasPermission = usersPermissions?.[requiredPermission] || false;

    if (!hasPermission) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};

export default PermissionRouteGuard;